import mixpanel from 'mixpanel-browser';
import { getEnvVariable } from './get-env-variable';
import { EventParams, MixpanelEvents } from '../contracts';
import { getSessionToken } from './get-session-token';

const mixPanelId = '36bc8102bd15fc0a7471651e632a1c1d';
let isMixpanelInitialized = false;

export const initProductEventsService = () => {
  if (isMixpanelInitialized) {
    return;
  }

  const mixpanelToken = getEnvVariable('REACT_APP_MIXPANEL_TOKEN', mixPanelId);
  if (!mixpanelToken) {
    console.warn('Mixpanel: REACT_APP_MIXPANEL_TOKEN not configured');
    return;
  }

  try {
    mixpanel.init(mixpanelToken, {
      debug: getEnvVariable('REACT_APP_ENV') !== 'production',
      track_pageview: true,
      persistence: 'localStorage',
    });
    isMixpanelInitialized = true;
  } catch (error) {
    console.error('Failed to initialize Mixpanel:', error);
    return;
  }
  const session_id = getSessionToken();
  if (!session_id) {
    return;
  }
  try {
    mixpanel.identify(session_id);
  } catch (error) {
    console.error('Failed to identify Mixpanel:', error);
  }
};

export const sendMixpanelEvent = (eventType: MixpanelEvents, params: Partial<EventParams>) => {
  if (!isMixpanelInitialized) {
    return;
  }

  const session_id = getSessionToken();
  const properties = {
    ...params,
    environment: getEnvVariable('REACT_APP_ENV', process.env.REACT_APP_ENV) || 'local',
    session_id,
    checkout_type: 'V2',
  };
  try {
    mixpanel.track(eventType, properties);
  } catch (error) {
    console.error(error);
  }
};
